import {defineMessages} from 'react-intl'

/** Every string of the points programme, in the shape the localisation team gets: id, defaultMessage, values */
export const loyaltyMessages = defineMessages({
  showPricesInPoints: {
    id: 'loyalty.showPricesInPoints',
    defaultMessage: 'Show prices in points'
  },
  maxPointsToRedeem: {
    id: 'loyalty.maxPointsToRedeem',
    defaultMessage: 'Max points to redeem'
  },
  pointsPrice: {
    id: 'loyalty.pointsPrice',
    defaultMessage:
      '{count, plural, one {{points} point} other {{points} points}} <cash>+ {cashAmount}</cash>'
  },
  pointsPriceTotal: {
    id: 'loyalty.pointsPriceTotal',
    defaultMessage:
      '{count, plural, one {{points} point} other {{points} points}} + {cashAmount} total'
  },
  pointsPriceTotalForStay: {
    id: 'loyalty.pointsPriceTotalForStay',
    defaultMessage:
      '{count, plural, one {{points} point} other {{points} points}} + {cashAmount} total {rooms, plural, one {1 room} other {# rooms}}, {nights, plural, one {1 night} other {# nights}}'
  },
  tierLevelsTitle: {
    id: 'loyalty.tierLevelsTitle',
    defaultMessage: 'Tier levels'
  },
  pointsCollected: {
    id: 'loyalty.pointsCollected',
    defaultMessage: 'Points collected'
  },
  memberNumber: {
    id: 'loyalty.memberNumber',
    defaultMessage: 'Member number'
  },
  memberNumberShort: {
    id: 'loyalty.memberNumberShort',
    defaultMessage: 'Mem. No. {number}'
  },
  redeemPointsTitle: {
    id: 'loyalty.redeemPointsTitle',
    defaultMessage: 'Redeem points to customize your price'
  },
  pointsAvailable: {
    id: 'loyalty.pointsAvailable',
    defaultMessage: 'Points available {points}'
  },
  usePointsField: {
    id: 'loyalty.usePointsField',
    defaultMessage: 'Use {field} points'
  },
  maxPointsToRedeemValue: {
    id: 'loyalty.maxPointsToRedeemValue',
    defaultMessage: 'Max points to redeem {points}'
  },
  pointsAfterRedemption: {
    id: 'loyalty.pointsAfterRedemption',
    defaultMessage: 'Points after redemption {points}'
  },
  totalReducedBy: {
    id: 'loyalty.totalReducedBy',
    defaultMessage: 'Total will be reduced by {amount}'
  },
  apply: {
    id: 'apply',
    defaultMessage: 'Apply'
  },
  applied: {
    id: 'loyalty.applied',
    defaultMessage: 'Applied'
  },
  pointsAppliedNewTotal: {
    id: 'loyalty.pointsAppliedNewTotal',
    defaultMessage:
      '{count, plural, one {# point applied. New total {amount}.} other {# points applied. New total {amount}.}}'
  },
  noPointsToRedeem: {
    id: 'loyalty.noPointsToRedeem',
    defaultMessage: 'You have no points to redeem yet'
  },
  earnPoints: {
    id: 'loyalty.earnPoints',
    defaultMessage:
      '{count, plural, one {+Earn {points} point} other {+Earn {points} points}}'
  },
  earnPointsInfoTitle: {
    id: 'loyalty.earnPointsInfoTitle',
    defaultMessage: 'How do hotel points work?'
  },
  earnPointsInfoContent: {
    id: 'loyalty.earnPointsInfoContent',
    defaultMessage:
      'Earn points in the {programName} program, the same balance as your flight points. Credited after your stay.'
  },
  pointsToEarn: {
    id: 'loyalty.pointsToEarn',
    defaultMessage:
      '{count, plural, one {{points} point} other {{points} points}}'
  },
  toBeEarned: {
    id: 'loyalty.toBeEarned',
    defaultMessage: 'to be earned'
  },
  howToEarnPoints: {
    id: 'loyalty.howToEarnPoints',
    defaultMessage: 'How to earn points?'
  },
  haveACoupon: {
    id: 'loyalty.haveACoupon',
    defaultMessage: 'Have a coupon?'
  },
  enterPromoCode: {
    id: 'loyalty.enterPromoCode',
    defaultMessage: 'Enter promo code'
  },
  couponApplied: {
    id: 'loyalty.couponApplied',
    defaultMessage: '{discount} coupon applied.'
  },
  codeNotRecognized: {
    id: 'loyalty.codeNotRecognized',
    defaultMessage: "We don't recognize this code. Try again."
  },
  pointsRedeemedSummary: {
    id: 'loyalty.pointsRedeemedSummary',
    defaultMessage: 'Points redeemed <muted>({points})</muted>'
  },
  couponAppliedSummary: {
    id: 'loyalty.couponAppliedSummary',
    defaultMessage: 'Coupon applied <muted>({discount})</muted>'
  }
})
